<template>
    <div id="app">
        <div class="top">
			<div class="logo"></div>
			<div class="nav">
				<router-link to="/">首 页</router-link>
				<a href="http://shop.qingningmaidan.com" target="_blank">商 城</a>
				<i></i>
				<router-link to="/download">即刻体验</router-link>
				<router-link to="/contact">联系我们</router-link>
			</div>
		</div>
        <router-view/>
		<div class="foot">
			<div class="link">
				<div class="icon"></div>
				<p>网站备案：<a href="https://beian.miit.gov.cn" target="_blank">闽ICP备2021001371号-1</a></p>
			</div>
		</div>
		<div class="foot_line"></div>
    </div>
</template>

<script>
    import '@/assets/css/public.css';

    export default {
        data() {
            return {}
        },
        created() {},
        mounted() {},
        computed: {},
        watch: {},
        methods: {},
        components: {}
    }
</script>

<style scoped lang="less">
	.foot{
		position: fixed;
		z-index: 100;
		left: 0;
		right: 0;
		bottom: 0;
		height: 40px;
		background: #28375B;
		display: flex;
		align-items: center;
		justify-content: center;
		.link{
			display: flex;
			align-items: center;
			justify-content: center;
			// cursor: pointer;
			.icon{
				width: 22px;
				height: 24px;
				background: url("assets/images/foot_pic.png") no-repeat;
				background-size: contain;
				-webkit-filter: grayscale(100%);
				-moz-filter: grayscale(100%);
				-ms-filter: grayscale(100%);
				-o-filter: grayscale(100%);
				filter: grayscale(100%);
				filter: gray;
			}
			p{
				padding-left: 5px;
				color: #677897;
				font-size: 12px;
				a{
					color: #677897;
				}
			}
			&:hover{
				.icon{
					-webkit-filter: grayscale(0%);
					-moz-filter: grayscale(0%);
					-ms-filter: grayscale(0%);
					-o-filter: grayscale(0%);
					filter: grayscale(0%);
					filter: gray;
				}
			}
		}
		
	}
	.foot_line{
		position: fixed;
		z-index: 100;
		left: 0;
		right: 0;
		bottom: 40px;
		height: 3px;
		background: linear-gradient(90deg, #00FFBD 0%, #83FF94 100%);
	}
	.top{
		position: fixed;
		z-index: 100;
		left: 0;
		right: 0;
		top: 0;
		height: 56px;
		background: #fff;
		display: flex;
		align-items: center;
		padding: 0 60px 0 40px;
		.logo {
		  width: 180px;
		  height: 36px;
		  background: url("assets/images/logo.png") no-repeat;
		  background-size: contain;
		}
		.nav{
			flex: 1;
			justify-content: flex-end;
			display: flex;
			align-items: center;
			height: 50px;
			a{
				font-weight: 500;
				margin-left: 40px;
				height: 56px;
				line-height: 56px;
				font-size: 15px;
				color: #28375B;
				&.router-link-exact-active{
					color: #0CE9B0;
					position: relative;
					font-weight: 800;
					&::before{
						content: '';
						position: absolute;
						z-index: 101;
						width: 16px;
						height: 3px;
						border-radius: 1.5px;
						background: #0CE9B0;
						bottom: 0;
						left: 50%;
						margin-left: -8px;
					}
				}
			}
			i{
				margin-left: 40px;
				width: 1px;
				height: 14px;
				background: #3B4664;
				display: inline-block;
			}
		}
	}
</style>



